import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import Grid from '@mui/material/Grid';
import { motion } from 'framer-motion';
import trustPaymentsLogo from '../../assets/partners/trust-payments.png';
import paysafeLogo from '../../assets/partners/paysafe-logo.png';
import partner1Logo from '../../assets/partners/partner-1.png';

interface Partner {
  name: string;
  logo: string;
}

const partners: Partner[] = [
  { name: 'TRUST Payments', logo: trustPaymentsLogo },
  { name: 'Paysafe', logo: paysafeLogo },
  { name: 'Partner', logo: partner1Logo }
];

const StatsAndIntegrationsSection: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: '#F9F9F9',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <Container maxWidth="xl" sx={{ width: '90%', mx: 'auto' }}>
        <Grid container spacing={8} alignItems="flex-start">
          {/* LEFT: Stats */}
          <Grid size={{ xs: 12, md: 6 }}>
            <motion.div
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              style={{ display: 'flex', flexDirection: 'row', gap: '80px', justifyContent: 'center' }}
            >
              <motion.div variants={itemVariants} style={{ textAlign: 'center' }}>
                <Typography sx={{ fontSize: { xs: '50px', md: '64px' }, fontWeight: '600 !imporant', color: 'cyan.500', lineHeight: 1, mb: '10px' }}>
                  150
                </Typography>
                <Typography component="h4" sx={{ fontSize: '18px !important', color: '#070707', textTransform: 'none', lineHeight: '1.4' }}>
                  Free upgrades on customer requests
                </Typography>
              </motion.div>
              <motion.div variants={itemVariants} style={{ textAlign: 'left', paddingLeft: '50px', maxWidth:'48.108%', flex: '0 0 auto' }}>
                <Typography sx={{ fontSize: { xs: '50px', md: '64px' }, fontWeight: '600 !imporant', color: '#52D6D6', lineHeight: '57px', mb: '15px' }}>
                  100
                </Typography>
                <Typography component="h4" sx={{ fontSize: '18px !important', color: '#070707', textTransform: 'none', lineHeight: '1.4' }}>
                  Project implementation
                </Typography>
              </motion.div>
            </motion.div>
          </Grid>

          {/* RIGHT: Integrations */}
          <Grid size={{ xs: 12, md: 6 }}>
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={containerVariants}
            >
              <Box component={motion.div} variants={itemVariants} sx={{ textAlign: { xs: 'center', md: 'left' }, mb: '30px' }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: '32px', md: '36px' },
                    fontWeight: 600,
                  }}
                >
                  Integrations with leading partners
                </Typography>
              </Box>

              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: 'repeat(2, 1fr)',
                    sm: 'repeat(3, 1fr)',
                  },
                  gap: '40px',
                  alignItems: 'center',
                }}
              >
                {partners.map((partner, index) => (
                  <motion.div
                    key={index}
                    variants={itemVariants}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '80px',
                    }}
                  >
                    <Box
                      component="img"
                      src={partner.logo}
                      alt={`${partner.name} logo`}
                      sx={{
                        maxWidth: '120px',
                        maxHeight: '40px',
                        objectFit: 'contain',
                      }}
                    />
                  </motion.div>
                ))}
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default StatsAndIntegrationsSection;
